import httpClient from '@/mixins/http-client'
import GroupRepository from '@/modules/users/group/infrastructure/persistence/api/axios/group_repository'

export default class UpdateGroupService {
  private repository: GroupRepository | null

  constructor(_repository: GroupRepository | null = null) {
    this.repository = _repository || new GroupRepository(httpClient, '/groups/')
  }

  update(id:string, payload: object) {
    return this.repository?.update(id, payload)
  }
}
